module.exports = __webpack_public_path__ + "img/egypt.18f5e988.svg";